import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { PageMemberCredentialDirectory } from 'components/pages/PageMemberCredentialDirectory';
import { changeIndividualFilter } from 'modules/membership/actions';
import { getFeatureToggleByKeySelector } from 'modules/featureToggle/selectors';
import { reCAPTCHAKeyConfigSelector } from 'modules/app/selectors';
import { USE_RE_CAPTCHA_DISABLED } from 'modules/featureToggle/constants';
import { IndividualSearch } from 'mxp-schemas/src/types/membership';

const mapActionCreators = (dispatch: Dispatch) => ({
  async changeIndividualFilter(individualSearchObject: IndividualSearch) {
    await dispatch(changeIndividualFilter(individualSearchObject));
  },
});

const mapStateToProps = (state: State.Root) => ({
  loading: false,
  useReCaptchaDisabled: getFeatureToggleByKeySelector(state, USE_RE_CAPTCHA_DISABLED),
  reCAPTCHAKey: reCAPTCHAKeyConfigSelector(state),
});

export const PageMemberCredentialDirectoryContainer = connect(
  mapStateToProps,
  mapActionCreators
)(PageMemberCredentialDirectory);
